import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_BASE_URL } from "../../config/env";
import { applyAuthHeaders } from "../../utils/authHeaders";
import { createBaseQueryWithReauth } from "./baseQueryWithReauth";

// chat endpoint names that need the chat token
const CHAT_ENDPOINTS = ["getMessages", "sendMessage"];

// base query with auth headers
const baseQuery = fetchBaseQuery({
  baseUrl: API_BASE_URL,
  // credentials: 'include', // IMPORTANT: sends HttpOnly cookie for refresh token
  prepareHeaders: (headers, { endpoint }) =>
    applyAuthHeaders(headers, { includeChatToken: CHAT_ENDPOINTS.includes(endpoint) }),
});

// wrap with reauth logic (proactive + reactive token refresh)
const baseQueryWithReauth = createBaseQueryWithReauth({
  baseQuery,
});

export const baseApi = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    "Auth",
    "Gallery",
    "Chat",
    "Badges",
    "Status",
    "Cards",
    "HandSummary",
    "AdminCards",
    "AdminCardSchedule",
    "AdminUserCards",
    "Invites",
    "Respect",
    "Scheduler",
    "SchedulerLogs",
    "AgentChat",
    "AgentGroupChat",
    "AgentChatReadState",
    "AgentAnnouncements",
    "AgentPresence",
    "BlogArticles",
    "BlogDrafts",
    "BlogBooks",
    "BlogWayback",
    "Reactions",
    "AgentGame",
    "EventDispatch",
    "AgentInspector",
    "ArtistsGallery",
    "Contributors",
    "ArtistsGalleryPending",
    "AotdToday",
    "AotdInfo",
    "AotdStatus",
    "AotdRaceState",
    "AotdRaceAudit",
    "AotdEmojiPenalty",
    "AotdEmojis",
    "AotdQuiz",
    "EmojiSelector",
    "EmojiRegistry",
    "EmojiCandidates",
    "Notif",
    "NotifMute",
    "ChatStyle",
    "VoiceConfig",
    "Contributions",
    "AdminContributions",
    "HomeBanner",
    "Game",
  ],
  endpoints: () => ({}),
});
